import { makeStyles } from "@material-ui/core";

import axios, { AxiosError } from "axios";
import toast from "react-hot-toast";

const useStyles = makeStyles((theme: any) => ({
    modalContainer: {
        zIndex: 100,
        display: "block",
        position: "relative",
        minWidth: "80% !important",
        maxHeight: "70% !important",
        paddingBottom: "50px",
        marginTop: "20px",
    },
    modalContent: {
        padding: 25,
        width: "100% !important",
    },
    modalTopRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 15,
    },
    modalErrorContainer: {
        marginBottom: 20,
        border: "1px solid black",
        padding: 10,
    },
    modalErrorMesage: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: 16,
        fontWeight: "bold",
    },
    modalStackTrace:{
        marginTop: 5,
        display: "none",
        maxHeight: 250,
        overflowY: "scroll",
        overflowX: "scroll",
        fontSize: 12,
        border: "1px solid black",
        padding: 15,
    },
    fullStackTraceContainer:{
        marginTop: 5,
        maxHeight: 250,
        overflowY: "scroll",
        overflowX: "scroll",
        fontSize: 12,
        border: "1px solid black",
        padding: 15,
    }
}));

export function extractErrorMessage(e: any, default_msg: string = "An error occured"){
    if(e.response.data.content.length > 0 ){
        toast.error(e.response.data.content[e.response.data.content.length - 1].message);
    } else {
        toast.error(default_msg)
    }
}


export function DisplayError(error: Error | AxiosError) {
    if (axios.isAxiosError(error))  {
        if(error.request.status === 500){
            if(error.response?.data){
                if(error.response.data.content){
                    /* Do nothing for now
                    const contentErrors = error.response.data.content as  IContentError[];
                    console.log(contentErrors);
                    toast(
                        (t) => (
                            <div >
                                    <div >
                                        <h1>Error</h1>
                                        <IconButton onClick={() => toast.dismiss(t.id)}>
                                            <MdClose />
                                        </IconButton>
                                    </div>
                                    <div>
                                        {
                                            contentErrors.slice(0).reverse().map((error,index) => 
                                                <div  key={index}>
                                                    <div  >
                                                        <div>
                                                            [{contentErrors.length - index}] Message: {error.message} - {error.exceptionClass}
                                                        </div>
                                                        <div>
                                                            <IconButton onClick={() => {navigator.clipboard.writeText(error.stacktrace.toString());toast.success("Stack trace copied!",{duration: 1})}}>
                                                                <MdContentCopy />
                                                            </IconButton>
                                                            <IconButton onClick={() => {exspand(index.toString())}}>
                                                                <MdOutlineArrowDownward />
                                                            </IconButton>
                                                        </div>
                                                    </div>
                                                    <div  id={index.toString()} style={{display: "none"}}>
                                                        {error.stacktrace}
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div>
                                        <div style={{display:'flex', float:'left',width:'100%', alignItems: 'center', columnGap: 10}}>
                                            <h3>Full stacktrace</h3>
                                            <IconButton onClick={() => {navigator.clipboard.writeText(contentErrors.map(error => error.stacktrace.concat()).toString());toast.success("Full stack trace copied!",{duration: 1})}}>
                                                <MdContentCopy />
                                            </IconButton>
                                        </div>
                                        <div >
                                            {
                                                contentErrors.slice(0).reverse().map((error,index) => 
                                                    <div>
                                                        {error.stacktrace}
                                                    </div>
                                                )
                                            }
                                        </div>

                                    </div>
                                </div>
                        ),
                        {
                            duration: 20000000,
                            position: "top-center",
                        }
                    );  
                    */
                } else {
                    toast.error("An error occurred")
                }
            } else {
                toast.error("500 Server Error")
            }
        } else if (error.request.status === 403) {
            if(error.response?.data){
                toast.error(error.response.data.toString())
            } else {
                toast.error("403 Forbidden")
            }
        } else if (error.request.status === 0){
            toast.error("Unable to reach server")
        } else {
            toast.error(error.request.status)
        }
    } else {
        console.log(error)
    }
}

function exspand(id: string){
    var body = document.getElementById(id);
    if(body){
        if(body.style.display === "none"){
            body.style.display = "block";
        } else {
            body.style.display = "none";
        }
    }
}